<template>
    <section class="course__area pt-115 pb-120 grey-bg">
        <div class="container">
            <div class="row">
                <div class="col-xxl-12">
                    <div class="section__title-wrapper mb-60 text-center">
                        <h2 class="section__title">GelişimP <span class="yellow-bg yellow-bg-big">Offline Kurslar<img src="../../assets/img/shape/yellow-bg.png" alt=""></span></h2>
                        <p>Geçmişte online olarak gerçekleştirdiğimiz programları kurs platformundan satın alarak izleyebilirsiniz.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="course in courses" :key="course.id" class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <div class="course__item white-bg mb-30 fix">
                        <div class="course__thumb w-img p-relative fix">
                            <img :src="course.image" :alt="course.title">
                        </div>
                        <div class="course__content">
                            <h3 class="course__title">{{ course.title }}</h3>
                            <p>{{ course.description }}</p>
                        </div>
                        <div class="course__more d-flex justify-content-between align-items-center">
                            <div class="course__btn">
                                <a :href="course.buttonUrl" target="_blank" class="link-btn">
                                    {{ course.buttonText || 'Detaylar' }}
                                    <i class="far fa-arrow-right"></i>
                                    <i class="far fa-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center mt-50">
                <a href="https://edumoso.com/collections/products" target="_blank" class="e-btn">
                    Tüm Kursları İncelemek İçin Tıklayınız
                    <i class="far fa-arrow-right"></i>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import { jsonService } from '@/services/jsonService'

export default {
    name: 'CourseSection',
    data() {
        return {
            courses: []
        }
    },
    async created() {
        const courses = await jsonService.getCourses()
        this.courses = courses.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    }
}
</script>

<style scoped>
.course__content {
    padding: 15px;
    height: 120px;
    display: flex;
    flex-direction: column;
}

.course__title {
    font-size: 20px;
    margin-bottom: 10px;
    font-weight: 700;
    color: #000000;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.course__content p {
    color: #666;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 1.5;
    display: -webkit-box;

    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    white-space: pre-line;
}

.course__more {
    padding: 15px;
    border-top: 1px solid #edeef3;
}

.link-btn {
    display: inline-block;
    color: #2b4eff;
    text-decoration: none;
    font-weight: 400;
    font-size: 14px;
}

.link-btn:hover {
    color: #0026ff;
}

.course__item {
    height: 90%;
    display: flex;
    flex-direction: column;
}

.course__thumb {
    position: relative;
    overflow: hidden;
}

.course__thumb img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    transition: all 0.3s ease;
}

.course__item:hover .course__thumb img {
    transform: scale(1.1);
}
.e-btn {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: 15px 35px;
   background: #2b4eff;
   color: #fff;
   border-radius: 4px;
   text-decoration: none;
   font-weight: 600;
   text-transform: capitalize;
   transition: all 0.3s ease;
}

.e-btn:hover {
   background: #2b4eff;
   transform: translateY(-3px);
}

.e-btn i {
   display: none;
}

@media (max-width: 991px) {
   
   .e-btn {
      font-size: 12px;
   }
}
</style>
